import { graphql } from "react-relay";

export const QUERY_FRAGMENT = graphql`
	fragment personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesListFragment on Query
	@refetchable(queryName: "personalizedNotificationTemplatesTable_Refetch")
	@argumentDefinitions(first: { type: "Int" }, after: { type: "String" }) {
		Admin {
			Notification {
				GetPersonalizedNotificationTemplates(first: $first, after: $after)
					@connection(
						key: "personalizedNotificationTemplatesTable_GetPersonalizedNotificationTemplates"
					) {
					__id
					pageInfo {
						endCursor
						hasPreviousPage
						hasNextPage
						startCursor
					}
					edges {
						node {
							...personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment
						}
					}
				}
			}
		}
		...createPersonalizedNotificationTemplateButton_PersonalizedNotificationTemplateFragment
	}
`;

export const PERSONALIZED_NOTIFICATION_TEMPLATE_FRAGMENT = graphql`
	fragment personalizedNotificationTemplatesTable_PersonalizedNotificationTemplatesFragment on PersonalizedNotificationTemplate
	@inline {
		id
		template {
			key
			title
		}
	}
`;
